import React, { useCallback, useState, VFC } from 'react';
import PeopleComponent from './components';
import { Person } from './types';

interface Props {
  loaded: boolean;
  people: Person[];
}

const People: VFC<Props> = ({ loaded, people }) => {
  const [tabValue, setTabValue] = useState<number>(0);

  const handleChangeTab = useCallback((id: number) => setTabValue(id), []);

  if (people.length < 1) return null;

  return (
    <PeopleComponent
      tabValue={tabValue}
      people={people}
      loaded={loaded}
      onChangeTab={handleChangeTab}
    />
  );
};

export default People;
